import Icon from '../components/Icon.vue'

Icon.register({
  recycle: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M184.6 261.9c3.2 14-12.1 24.6-24.1 17.2l-40.7-25.5-50.9 81.4c-13.3 21.3 2.1 49 27.1 49h52c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-51.9c-75.3 0-121.3-83-81.4-146.9l50.8-81.4-40.7-25.4c-12.1-7.5-9-26 4.9-29.2l110.2-25.5c8.6-2 17.2 3.4 19.2 12zM283.1 79c-12.3-19.7-41.5-20.3-54.3 0l-18 28.7c-3.5 5.6-10.9 7.3-16.5 3.8l-33.9-21.2c-5.6-3.5-7.3-10.9-3.8-16.5l18-28.8c37.6-60.2 125.3-60 162.8 0l41.3 66.1 40.7-25.4c12.1-7.6 27.3 3.3 24.1 17.2l-25.5 110.2c-2 8.6-10.5 14-19.2 12l-110.2-25.5c-13.9-3.2-16.9-21.6-4.9-29.2l40.7-25.5zM497.3 301.1c39.9 63.9-6.1 146.9-81.4 146.9h-95.9v48c0 14.3-17.3 21.3-27.3 11.3l-80-80c-6.2-6.2-6.2-16.4 0-22.6l80-80c10.1-10.1 27.3-2.9 27.3 11.3v48h96c25.1 0 40.4-27.7 27.1-49l-27.6-44.1c-3.5-5.6-1.8-13 3.8-16.5l33.9-21.2c5.6-3.5 13-1.8 16.5 3.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/recycle.js
// module id = 1682
// module chunks = 0